// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__eF96t","dragIcon":"SortableItem_dragIcon__31cGO","disabled":"SortableItem_disabled__3265u"};